"use strict";
/**
 * @module Services.FetchJMXValues
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A list of JMX object names.
 */
var JMXFetchRequest = /** @class */ (function () {
    /**
     * Create a new JMXFetchRequest instance
     *
     * @param names the names
     */
    function JMXFetchRequest(names, isClustered) {
        this.names = names;
        this.isClustered = isClustered;
    }
    return JMXFetchRequest;
}());
exports.JMXFetchRequest = JMXFetchRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/fetch-jmx-values/jmx-fetch-request.js
// module id = 621
// module chunks = 0